import { useIntl } from 'react-intl';
import { Outlet, useParams } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout.tsx';
import Tab from 'src/components/navigation/Tab.tsx';
import TabRow from 'src/components/navigation/TabRow.tsx';
import { pricingPlansMessages } from 'src/features/pricingPlans/utils/messages';

const ParkingPricingPlansLayout = () => {
    const { parkingId } = useParams();
    const { formatMessage } = useIntl();

    return (
        <>
            <TabRow>
                <Tab end to={`/parking-management/${parkingId}/pricing-plans`}>
                    {formatMessage(pricingPlansMessages.allPricingPlans)}
                </Tab>
                <Tab end to={`/parking-management/${parkingId}/pricing-plans/points`}>
                    {formatMessage(pricingPlansMessages.pricingPlansByPoints)}
                </Tab>
            </TabRow>
            <MainLayout>
                <Outlet />
            </MainLayout>
        </>
    );
};

export default ParkingPricingPlansLayout;
